<template>
  <div>
    <a-select @change="handleSelectChange" style="width: 100%" v-if="query">
      <a-select-option :key="index" :value="item.value" v-for="(item, index) in queryOption">{{ item.text }}</a-select-option>
    </a-select>
    <a-switch :disabled="disabled" @change="handleChange" :checked-children="checkedChildren" :un-checked-children="unCheckedChildren" v-else v-model="checkStatus" />
  </div>
</template>
<script>

  export default {
    name: 'JSwitch',
    props: {
      value: {
        type: String | Number,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      options: {
        type: Array,
        required: false,
        default: () => ['Y', 'N']
      },
      query: {
        type: Boolean,
        required: false,
        default: false
      },
      checkedChildren: {
        type: String
      },
      unCheckedChildren: {
        type: String
      }
    },
    data () {
      return {
        checkStatus: false
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (val) {
          if (!this.query) {
            if (!val) {
              this.checkStatus = false
              this.$emit('change', this.options[1]);
            } else {
              if (this.options[0] == val) {
                this.checkStatus = true
              } else {
                this.checkStatus = false
              }
            }
          }

        }
      }
    },
    computed: {
      queryOption () {
        let arr = []
        arr.push({ value: this.options[0], text: '是' })
        arr.push({ value: this.options[1], text: '否' })
        return arr;
      }
    },
    methods: {
      handleChange (checked) {
        let flag = checked === false ? this.options[1] : this.options[0];
        this.$emit('change', flag);
      },
      handleSelectChange (value) {
        this.$emit('change', value);
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>
